module.exports = __webpack_public_path__ + "img/access-point.45a4db0d.svg";